<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="claimsSearch1"
                     :inputs="searchInputsEx"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClickEx" />
        <hr />
        <div>
            <b-dropdown size="lg" id="claimActions" text="Actions" class="m-md-2">
                <b-dropdown-item @click="handleExportClick">
                    Export
                </b-dropdown-item>
                <b-dropdown-item :disabled="!(selectedItems && selectedItems.length > 0)"
                                 @click="handleStatusClick">
                    Change status
                </b-dropdown-item>
                <b-dropdown-item :disabled="!(selectedItems && selectedItems.length > 0)"
                                 @click="handleTaskClick">
                    Mark As
                </b-dropdown-item>
            </b-dropdown>
        </div>

        <hr />
        <transition name="fade">
            <select-status v-if="showStatus && (selectedItems && selectedItems.length > 0)"
                           :statuses="manualStatuses"
                           :reasons="declinationReasons"
                           :button_text="`Set Status (${selectedItems.length} records)`"
                           class="mb-2 border-bottom"
                           @button-click="handleUpdateSelectedClick" />
        </transition>

        <transition name="fade">
            <select-task v-if="showFlag && (selectedItems && selectedItems.length > 0)"
                         :tasks="options"
                         :button_text="`Set Task (${selectedItems.length} records)`"
                         class="mb-2 border-bottom"
                         @button-click="handleUpdateFlagsClick" />
        </transition>

        <transition name="fade">
            <data-list-csv v-if="showExport"
                           class="mb-2 border-bottom"
                           :dataCols="claimsCols"
                           :dataListItems="claimsList"
                           :selectedItems="selectedItems">
            </data-list-csv>

        </transition>
        <div class="row">
            <div class="col">
                <page-size v-model="pageSize"
                           @input="handlePageSizeChange" />
            </div>
            <div class="col">
                <order-by v-model="selectedOrderBy"
                          :options="orderByOptions"
                          @goClick="handleOrderByClick" />
            </div>
        </div>

        <data-list-pagination :dataCols="claimsCols"
                              :dataListItems="claimsList"
                              :showCheckbox="true"
                              :tableClass="'table table-striped table-sm'"
                              :totalRecords="totalRecords"
                              :pageNumber="pageNumber"
                              :pageSize="pageSize"
                              @change="handleSelectedItemsChange"
                              @dbl-click="handleItemDblClick"
                              @pagination-input="handlePagenationInput" />
        <!--<hr />
        <data-list :dataCols="claimsCols"
                   :dataListItems="claimsList"
                   :tableClass="'table table-striped table-sm'"
                   :showCheckbox="true"
                   @change="handleSelectedItemsChange"
                   @dbl-click="handleItemDblClick" />

        <b-pagination align="center"
                      size="md"
                      :total-rows="totalRecords"
                      v-model="pageNumber"
                      :per-page="pageSize"
                      @input="handlePagenationInput" />-->

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>
import claimsSearch from '@/mixins/claimsSearch.js'
import OrderBy from '@/components/OrderBy.vue'
import PageHeader from '@/components/PageHeader.vue'
    import DataList from '@/components/DataList.vue'
    import DataListPagination from "@/components/DataListPagination.vue";
import DataListCSV from '@/components/DataListCSV.vue'
import SelectStatus from '@/components/SelectStatus.vue'
import SelectTask from '@/components/SelectTask.vue'
import PageSize from '@/components/PageSize.vue'
import SearchForm from '@/components/SearchForm.vue'
import { searchInputs, searchInputs2, searchInputs3 } from '@/ui.config/inputs/claimsBucket1SearchInputs'
import { claimsCols } from '@/ui.config/cols/claimsBucket1ClaimsCols'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

let indexOfObject = function (array, prop, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][prop] === value) {
            return i;
        }
    }
    return -1;
}

import { mapActions } from 'vuex'

export default {
    name: 'ClaimsBucket1',
    mixins: [
        claimsSearch,
    ],
    components: {
        PageHeader,
        DataList,
        'data-list-pagination': DataListPagination,
        'data-list-csv': DataListCSV,
        'select-status': SelectStatus,
        'select-task': SelectTask,
        PageSize,
        SearchForm,
        Loading,
        OrderBy
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Claims',
            },
            searchInputs: [],
            claimsCols: claimsCols,

            insuranceLineTypes: [
                {
                    id: 1,
                    label: 'GADGET'
                },
                {
                    id: 2,
                    label: 'TIGA'
                },
                {
                    id: 3,
                    label: 'TGA'
                },
                {
                    id: 5,
                    label: 'POLICE FED'
                }
            ],
            // TEST
            selected: [], // Must be an array reference!
            options: [
                { text: 'Updated EVO with claim details and added Reference', value: '1000' },
                { text: 'Updated EVO with supporting documents', value: '1001' },
                { text: 'Updated EVO with repair paperwork', value: '1002' },
                { text: 'Updated EVO with selected repair option details', value: '1003' },
                { text: 'Updated EVO with cancelled repair option details', value: '1004' },
                { text: 'Updated EVO with excess card payment', value: '1005' },
                { text: 'FT Manually reviewed', value: '1013' }
            ],

            // Override mixin
            orderByOptions: [
                {
                    id: 0,
                    key: 'ClaimantEmail',
                    label: 'Claimant Email'
                },
                {
                    id: 1,
                    key: 'DateCreated',
                    label: 'Submitted Date'
                },
                {
                    id: 2,
                    key: 'IncidentDate',
                    label: 'incident Date'
                }
            ],

            updatedStatus: null,
            selectedDeclinationReason: null,

            claimStatuses: []
            
        }
    },
    beforeMount() {
        //this.claimsSearch({ fastTrack: this.fastTrack, portalGroupId: this.portalGroupId }, 1)       
        this.fetchResellers()
        this.fetchIncidentTypes()
        this.fetchDeclinationReasons()
        this.fetchManualStatuses()
        this.fetchUnderwriters()
    },
    mounted() { 
            this.clearClaimsList()
        if (this.fastTrack) {
            this.searchInputs = searchInputs2
        } else {
            if (typeof this.insuranceLineId != 'undefined' && this.insuranceLineId != null) {
                this.searchInputs = searchInputs
            } else {
                this.searchInputs = searchInputs3
            }
        }

        this.fetchStatuses()
            .then(
                response => {
                   this.claimStatuses = response.data
                },
                error => console.log(error)
            )
                .catch(error => console.log(error));

    },
    computed: {
        searchInputsEx2() {
            var { resellers, incidentTypes,  searchInputs } = this

            if (searchInputs && searchInputs.length > 0) {
                if (resellers) {
                    searchInputs[0].options = resellers
                }

                if (incidentTypes) {
                    searchInputs[6].options = incidentTypes
                }
            }
            return searchInputs
        },
        searchInputsEx() {
            var { resellers, incidentTypes, searchInputs, insuranceLineTypes, claimStatuses, underwriters } = this

            if (searchInputs && searchInputs.length > 0) {

                if (insuranceLineTypes) {
                    let insuranceLineIndex = indexOfObject(searchInputs, 'id', 'insuranceLine')
                    if (insuranceLineIndex > -1) {
                        searchInputs[insuranceLineIndex].options = insuranceLineTypes
                    }
                }
                
                if (resellers) {
                    let resellerIndex = indexOfObject(searchInputs, 'id', 'reseller')
                    if (resellerIndex > -1) {
                        searchInputs[resellerIndex].options = resellers
                    }
                }

                if (incidentTypes) {
                    let incidentTypeIndex = indexOfObject(searchInputs, 'id', 'incidentType')
                    searchInputs[incidentTypeIndex].options = incidentTypes
                }

                if (claimStatuses) {
                    let claimStatusesIndex = indexOfObject(searchInputs, 'id', 'claimStatus')
                    searchInputs[claimStatusesIndex].options = claimStatuses
                }

                if (underwriters) {
                    let underwritersIndex = indexOfObject(searchInputs, 'id', 'underwriter')
                    searchInputs[underwritersIndex].options = underwriters
                }

                if (this.$route.path == '/buckets/bucket4') {
                    if (indexOfObject(searchInputs, 'id', 'hasPolicyData') == -1) {
                        searchInputs.push(
                            {
                                id: 'hasPolicyData',
                                label: 'Policy Data Imported',
                                type: 'select',
                                options: [
                                    {
                                        id: 1,
                                        label: 'Yes'
                                    },
                                    {
                                        id: 2,
                                        label: 'No'
                                    }
                                ]
                            })
                    }
                }
            }

            return searchInputs
        },
    },
    methods: {
        ...mapActions(['fetchStatuses']),
        buildSearchValues(payload) {
            if (payload != null) {

                let { reseller, claimReference, relatedReference, policyNumber, claimantEmail, incidentDate,
                    incidentType, fastTrackFilter, insuranceLine, portalGroupId, claimStatus, underwriter, hasPolicyData,
                    personalCircumstances } = payload
                let fastTrack = null

                if (fastTrackFilter) {
                    if (fastTrackFilter.id == 1) {
                        fastTrack = true
                    }

                    if (fastTrackFilter.id == 2) {
                        fastTrack = false
                    }
                }

                let criteria = {
                    resellerId: reseller ? reseller.id : null,
                    claimReference,
                    relatedReference,
                    policyNumber,
                    claimantEmail,
                    incidentDate,
                    incidentTypeId: incidentType ? incidentType.id : null,
                    fastTrack,
                    insuranceLineId: insuranceLine ? insuranceLine.id : null,
                    portalGroupId,
                    claimStatus: claimStatus ? claimStatus.id : null,
                    underwriterId: underwriter ? underwriter.id: null
                }

                if (hasPolicyData) {
                    if (hasPolicyData.id == 1) {
                        criteria.ignoreNoPolicyData = false;
                        criteria.noPolicyData = false;
                    }
                    if (hasPolicyData.id == 2) {
                        criteria.ignoreNoPolicyData = false;
                        criteria.noPolicyData = true;
                    }
                }

                if (personalCircumstances && personalCircumstances.hasOwnProperty('id')) {
                    if (personalCircumstances.id == 3)
                        criteria.ignorePersonalCircumstances = true
                    else {
                        criteria.ignorePersonalCircumstances = false
                        criteria.personalCircumstances = personalCircumstances.id == 0 ? false : true
                    }
                }
                return criteria
            } 
        },
        handleUpdateSelectedClick(evPayload) {
            let { status: updatedStatus, reason: selectedDeclinationReason } = evPayload
            let { selectedItems } = this

            this.updatedStatus = null
            this.selectedDeclinationReason = null
            this.selectedItems = []
            this.showStatus = false

            let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))

            if (this.fastTrack)
                criteria.fastTrack = this.fastTrack

            let payload = {
                claimSearchCriteria: criteria,
                statusId: updatedStatus ? updatedStatus.id : null,
                reasonId: selectedDeclinationReason ? selectedDeclinationReason.id : null,
                claims: selectedItems.map(i => {
                    return {
                        claimId: i.claimId,
                        rowVersion: i.claimRowVersion
                    }
                })
            }
            this.updateClaims(payload)
        },
        handleUpdateFlagsClick(evPayload) {
            let selected = evPayload

            let { selectedItems } = this
            let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))

            if (this.fastTrack)
                criteria.fastTrack = this.fastTrack

            this.selectedItems = []
            this.selected = null
            this.showFlag = false

            this.updateClaimsTaskFlags(
                {
                    claimSearchCriteria: criteria,
                    claims: selectedItems.map(i => {
                        return {
                            claimId: i.claimId,
                            rowVersion: i.claimRowVersion
                        }
                    }),
                    taskFlags: selected
                }
            )
        },
    }
}
</script>

<style>

</style>
